import { render, staticRenderFns } from "./UserCreateForm.vue?vue&type=template&id=5af68e44&scoped=true&"
import script from "./UserCreateForm.vue?vue&type=script&lang=ts&"
export * from "./UserCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af68e44",
  null
  
)

export default component.exports